import {Component, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {ActivatedRoute, Router} from '@angular/router';
import {Configuration} from '@shared/models/configuration';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {ParticleService} from '@core/services/particle.service';
import {PlatformMailCellViewerComponent} from '../cell-components/platform-mail-cell-viewer/platform-mail-cell-viewer.component';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {Location} from '@angular/common';
import {InboxComposeDialogComponent} from '../compose/compose.component';
import {RowClassArgs} from '@progress/kendo-angular-grid';
import {CommandService} from '@core/services/command.service';
import {MarkMailAsReadCommand} from '../../commands/inbox.command';
import {InboxState} from '../../store/reducers/inbox.reducers';
import {Store} from '@ngrx/store';
import {getInboxAlertMessage} from '../../store/selectors/inbox.selectors';
import {InboxControllerService} from '@features/inbox/services/inbox-controller.service';
import {TabModel} from '@shared/models/platform-tool-models';

@Component({
    standalone: false,
    selector: 'particle-inbox',
  templateUrl: './inbox.component.html',
  styleUrls: ['./inbox.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InboxComponent implements OnInit, OnDestroy {
  sourceKey: string;
  routerState: any;
  invalidateSubject: InvalidateSubject;
  unSubscribe$ = new Subject<void>();
  labelId: string;
  inboxAlertMessage$: any;
  mailId: any;
  reply: any;
  serviceName = '';
  api = '';
  current_date = new Date('2025-08-17');
  @Input() selectedTab: TabModel;

  params = {
    ViewType: 'TileView',
    VirtualGridTileViewTemplate: 'PlatformMailCardViewerComponent'
  };

  constructor(protected activatedRoute: ActivatedRoute,
              private dialogService: DialogService,
              private particleService: ParticleService,
              public dialog: MatDialog,
              private router: Router,
              private location: Location,
              private commandService: CommandService,
              private inboxStore: Store<InboxState>,
              private inboxControllerService: InboxControllerService
  ) {
    this.sourceKey = 'PlatformMail';
    this.invalidateSubject = new InvalidateSubject();
    particleService.registerCellComponent('PlatformMailCellViewer', PlatformMailCellViewerComponent);
  }

  updatedDate(date: any) {
    this.current_date = date;
  }
  ngOnInit() {
    console.log(this.selectedTab);
    this.serviceName = this.selectedTab.tabData['ServiceName'];
    this.api = this.selectedTab.tabData['Api'];
    this.inboxAlertMessage$ = this.inboxStore.select(getInboxAlertMessage);
    this.inboxAlertMessage$
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe(state => {
        if (state) {
          this.invalidateSubject.invalidate();
        }
      });
    this.activatedRoute.params.pipe(takeUntil(this.unSubscribe$)).subscribe((params: any) => {
      if (params && params.label && params.mailId) {
        this.labelId = params.label;
        // const dialogRef = this.dialog.open(InboxDetailsDialogComponent, {
        //   data: params.mailId
        // });

        const dialogModel = DialogModel.create('Message', 'MailDetailContentComponent', {
          mailId: params.mailId
        });
        dialogModel.maxWidth = '800px';
        dialogModel.minWidth = '800px';
        this.dialogService.showOkCancelDialog(dialogModel).subscribe(actionState => {
          if (actionState && actionState.action === 'OK') {
            this.location.replaceState(`mail/${this.labelId}`);
            this.invalidateSubject.invalidate();
          }
        });
      }
      if (params && params.label) {
        this.labelId = params.label;
        const query = Configuration.getSmartGridConfig(this.sourceKey);
        query.Parameters['LABEL'] = params.label;
        this.invalidateSubject.invalidate();
      }
    });
  }

  ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  onGridCellValueChange($event) {
    switch ($event.action.id) {
      case 'Open':
        this.openMail($event);
        break;
      case 'Reply':
        this.openMail($event);
        break;
      case 'MarkAsRead':
        this.commandService.executeCommand(new MarkMailAsReadCommand($event.item.id, true))
          .pipe(takeUntil(this.unSubscribe$)).subscribe(state => {
          this.invalidateSubject.invalidate();
        });
        break;
      case 'MarkAsUnRead':
        this.commandService.executeCommand(new MarkMailAsReadCommand($event.item.id, false))
          .pipe(takeUntil(this.unSubscribe$)).subscribe(state => {
          this.invalidateSubject.invalidate();
        });
        break;
    }

  }

  private openMail($event) {
    this.location.replaceState(`mail/${this.labelId}/${$event.item.id}`);
    this.mailId = $event.item.id;
    this.inboxControllerService.setCurrentMailid(this.mailId);
    this.reply = $event.action.id === 'Reply';
    // const dialogModel = DialogModel.create('Message', 'MailThreadComponent', {
    //   mailId: $event.item.id,
    //   reply: $event.action.id === 'Reply'
    // });
    // dialogModel.maxWidth = '800px';
    // dialogModel.minWidth = '800px';
    // this.dialogService.showOkCancelDialog(dialogModel).subscribe(actionState => {
    //   if (actionState && actionState.action === 'OK') {
    //     this.location.replaceState(`mail/${this.labelId}`);
    //   }
    // });
  }

  composeDialog() {
    this.dialog.open(InboxComposeDialogComponent, <MatDialogConfig>{
      width: '1000px',
      position: {top: '100px'},
    });
  }

  public rowCallback = (context: RowClassArgs) => {
    return context.dataItem.cells.IsRead.value ? 'read-msg' : 'unread-msg';
  };
}
